const { updateSyncErrors, touch } = require('redux-form/lib/actions').default;
import { change } from 'redux-form';
import { parseFormPostData } from '../api/utils';
import { hasSocialAccount } from '../utils';
import { getLogInFormData } from './utils';
import { sleep } from '../components/utils';
import { LOOKUP_ERROR_SPEC } from '../api';
import { logInUser as logInUserApi } from '../api/login';
import {
    showAuthNotification,
    redirectToSignUp,
    hideCaptcha,
    submitSuccessRedirect,
} from './auth';
import { LOG_IN_FORM, CAPTCHA_FIELD } from '../constants';

import { GA_EVENTBRITE, GA_FACEBOOK, GA_APPLE } from '../constants/analytics';

import {
    UNKNOWN_ERROR_MESSAGE,
    LOCKED_ACCOUNT_ERROR_MESSAGE,
    MUST_CHANGE_PASSWORD_ERROR_MESSAGE,
    SUSPENDED_ACCOUNT_ERROR_MESSAGE,
    NOT_EMAIL_ASSOCIATED,
    CREATE_ACCOUNT,
    PASSWORD_INCORRECT,
    LOGIN_SOFT_ACCOUNT,
    ACCOUNT_CONNECTED_TO_FACEBOOK_ERROR_MESSAGE,
    ACCOUNT_CONNECTED_TO_APPLE_ERROR_MESSAGE,
    ACCOUNT_CONNECTED_TO_APPLE_AND_FB_ERROR_MESSAGE,
    ACCOUNT_CONNECTED_TO_SOCIAL_ERROR_MESSAGE,
} from '../constants/messages';

import {
    trackLoginClicked,
    trackAccountConnectedToFacebookAndApple,
    trackAccountAlreadyConnectedWithFB,
    trackAccountConnectedToApple,
    trackLoginSuccessOneStep,
    trackPasswordIncorrect,
} from './gaTracking';

/**
 * Catch the error and shows the specific error message to the user.
 */
export const handleOnErrorLogin = (dispatch, state) => (parsedError) => {
    const { error } = parsedError;
    const {
        authentication: { email, socialSSOSettings },
        lookup: { socialConnected },
    } = state;
    switch (error) {
        case 'USER_PASSWORD_INVALID': // Invalid password
        case 'ACCESS_DENIED':
            trackPasswordIncorrect({ state });
            dispatch(
                showAuthNotification({
                    message: PASSWORD_INCORRECT,
                }),
            );
            dispatch(
                updateSyncErrors(
                    LOG_IN_FORM,
                    LOOKUP_ERROR_SPEC['PASSWORD_INCORRECT'],
                ),
            );
            dispatch(touch(LOG_IN_FORM, 'password'));
            break;

        case 'USER_EMAIL_INVALID': // Email doesn't exist
            dispatch(
                showAuthNotification({
                    message: NOT_EMAIL_ASSOCIATED,
                    onClick: redirectToSignUp,
                    buttonCTA: CREATE_ACCOUNT,
                }),
            );
            break;

        case 'USER_HAS_NO_PASSWORD': // Soft account or account linked with social
            if (socialConnected) {
                // Linked with social
                if (
                    hasSocialAccount({
                        socialSSOSettings,
                        signInMethods: socialConnected,
                        socialToCompare: [GA_FACEBOOK, GA_APPLE],
                    })
                ) {
                    trackAccountConnectedToFacebookAndApple({ state });
                    dispatch(
                        showAuthNotification({
                            message: ACCOUNT_CONNECTED_TO_APPLE_AND_FB_ERROR_MESSAGE,
                        }),
                    );
                } else if (
                    hasSocialAccount({
                        socialSSOSettings,
                        signInMethods: socialConnected,
                        socialToCompare: [GA_FACEBOOK],
                    })
                ) {
                    trackAccountAlreadyConnectedWithFB({
                        state,
                    });
                    dispatch(
                        showAuthNotification({
                            message: ACCOUNT_CONNECTED_TO_FACEBOOK_ERROR_MESSAGE,
                        }),
                    );
                } else if (
                    hasSocialAccount({
                        socialSSOSettings,
                        signInMethods: socialConnected,
                        socialToCompare: [GA_APPLE],
                    })
                ) {
                    trackAccountConnectedToApple({ state });
                    dispatch(
                        showAuthNotification({
                            message: ACCOUNT_CONNECTED_TO_APPLE_ERROR_MESSAGE,
                        }),
                    );
                } else {
                    //It's linked with different social
                    dispatch(
                        showAuthNotification({
                            message: ACCOUNT_CONNECTED_TO_SOCIAL_ERROR_MESSAGE,
                        }),
                    );
                }
            } else {
                // Soft account
                dispatch(
                    showAuthNotification({
                        message: LOGIN_SOFT_ACCOUNT.replace('{email}', email),
                    }),
                );
            }
            break;

        case 'FORBIDDEN': // Account Locked
            dispatch(
                showAuthNotification({
                    message: LOCKED_ACCOUNT_ERROR_MESSAGE,
                }),
            );

            break;

        case 'USER_ACCOUNT_SUSPENDED': // Account suspended
            dispatch(
                showAuthNotification({
                    message: SUSPENDED_ACCOUNT_ERROR_MESSAGE,
                }),
            );
            break;

        case 'CREDENTIALS_MUST_CHANGE': // Password must be changed before login
            dispatch(
                showAuthNotification({
                    message: MUST_CHANGE_PASSWORD_ERROR_MESSAGE,
                }),
            );
            break;

        default:
            // Unknown error, let the user know and reject the promise
            dispatch(
                showAuthNotification({
                    message: UNKNOWN_ERROR_MESSAGE,
                }),
            );
            break;
    }
    return Promise.resolve();
};
/**
 * Try to log in user using mail and password completed in  LogIn Form.
 */
export const logInUser = (data) => async (dispatch, getState) => {
    let state = getState();
    let {
        lookup: { lookupLoading },
    } = state;
    while (lookupLoading === true) {
        // wait until loading finish
        await sleep(1500);
        state = getState();
        lookupLoading = state.lookup.lookupLoading;
    }
    dispatch(hideCaptcha());
    dispatch(change(LOG_IN_FORM, CAPTCHA_FIELD, null));
    trackLoginClicked({ sourceProvider: GA_EVENTBRITE, state });
    return logInUserApi({
        data: parseFormPostData(getLogInFormData(data, getState, true)),
    })
        .then((response) => {
            trackLoginSuccessOneStep({
                sourceProvider: GA_EVENTBRITE,
                state,
            });
            return dispatch(submitSuccessRedirect(response['redirect_url']));
        })
        .catch(handleOnErrorLogin(dispatch, state));
};
